import Events from './eventsActions';
import Filters from './filtersActions';

export default {
  ...Events,
  ...Filters
};



// WEBPACK FOOTER //
// ./src/actions/events/index.js